import React from "react";

const HORIZONTAL_LOGO = "https://customer-assets.emergentagent.com/job_practice-portal-15/artifacts/w2lq6860_Logo%20Title%20-%20no%20background.png";

const HEADER = { color: "#9B7D5A" };
const PRIMARY = { color: "#2C2825" };
const SECONDARY = { color: "#8A7968" };

export default function Footer() {
    return (
        <footer data-testid="site-footer" style={{ background: "#EDE8E1" }}>
            <div className="mx-auto max-w-[1400px] px-6 lg:px-12 py-20 lg:py-28">
                <div className="grid lg:grid-cols-12 gap-12 lg:gap-20">
                    {/* Brand */}
                    <div className="lg:col-span-5">
                        <div className="overflow-hidden h-32 sm:h-40 lg:h-48 w-full max-w-[480px]">
                            <img
                                src={HORIZONTAL_LOGO}
                                alt="Alchemy Practice"
                                className="w-full h-full object-cover object-left"
                            />
                        </div>
                        <p className="mt-2 font-serif italic text-2xl leading-snug max-w-md" style={PRIMARY}>
                            "Healing isn't becoming someone new; it's remembering who you were before the world told you who to be."
                        </p>
                    </div>

                    {/* Practice info */}
                    <div className="lg:col-span-4">
                        <p className="editorial-eyebrow" style={HEADER}>The Practice</p>
                        <ul className="mt-6 space-y-3 leading-relaxed" style={PRIMARY}>
                            <li>Austine, Licensed Professional Counselor</li>
                            <li>Wisconsin & Colorado, telehealth</li>
                            <li>By appointment only</li>
                        </ul>

                        <p className="editorial-eyebrow mt-12" style={HEADER}>Begin</p>
                        <ul className="mt-6 space-y-3">
                            <li>
                                <a
                                    href="https://alchemy-practice.clientsecure.me/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="gold-link"
                                    style={PRIMARY}
                                    data-testid="footer-book-link"
                                >
                                    Book a Consultation
                                </a>
                            </li>
                            <li>
                                <a href="#contact" className="gold-link" style={PRIMARY}>Send a Note</a>
                            </li>
                            <li>
                                <a href="#contact" className="gold-link" style={PRIMARY}>Subscribe to The Letter</a>
                            </li>
                        </ul>
                    </div>

                    {/* Disclaimer */}
                    <div className="lg:col-span-3">
                        <p className="editorial-eyebrow" style={HEADER}>A Note on Ethics</p>
                        <p className="mt-6 text-sm leading-relaxed" style={SECONDARY}>
                            In accordance with Wisconsin licensing board ethics, this site does not
                            display client testimonials. Therapy is private, and we honor that,
                            quietly and completely.
                        </p>
                    </div>
                </div>

                {/* Good Faith Estimate: No Surprises Act */}
                <div className="mt-16 pt-10 border-t" style={{ borderColor: "#E2DDD8" }} data-testid="good-faith-clause">
                    <p className="editorial-eyebrow" style={HEADER}>Good Faith Estimate</p>
                    <p className="mt-5 text-sm leading-relaxed max-w-4xl" style={SECONDARY}>
                        You have the right to receive a Good Faith Estimate explaining how much your medical
                        and mental health care will cost. Under the law (the No Surprises Act), health care
                        providers are required to give patients who don't have insurance, or who are not
                        using insurance, an estimate of the expected charges for medical services, including
                        psychotherapy services. You have the right to receive a Good Faith Estimate for the
                        total expected cost of any non-emergency services, including psychotherapy. You can
                        ask your health care provider, and any other provider you choose, for a Good Faith
                        Estimate before you schedule a service. If you receive a bill that is at least $400
                        more than your Good Faith Estimate, you can dispute the bill. Make sure to save a
                        copy or picture of your Good Faith Estimate. For questions or more information about
                        your right to a Good Faith Estimate, visit{" "}
                        <a
                            href="https://www.cms.gov/nosurprises"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="underline transition-colors"
                            style={HEADER}
                        >
                            www.cms.gov/nosurprises
                        </a>{" "}
                        or call 1-800-985-3059.
                    </p>
                </div>

                <div className="mt-12 pt-10 border-t flex flex-col md:flex-row items-start md:items-center justify-between gap-6" style={{ borderColor: "#E2DDD8" }}>
                    <p className="text-xs tracking-[0.2em] uppercase" style={SECONDARY}>
                        © {new Date().getFullYear()} Alchemy Practice. All rights reserved.
                    </p>
                    <div className="flex items-center gap-6 text-xs tracking-[0.2em] uppercase" style={SECONDARY}>
                        <span style={HEADER}>✦</span>
                        <span>If you are in crisis, please call or text 988.</span>
                    </div>
                </div>
            </div>
        </footer>
    );
}
